import { createSelector } from 'reselect';

const selectDbnpRegistries = (state: any) => state.dbnpRegistries;


export const selectDbnpRegistriesCurrentItem = createSelector([selectDbnpRegistries], (dbnpRegistries) => dbnpRegistries.current);

export const selectDbnpRegistriesListItems = createSelector([selectDbnpRegistries], (dbnpRegistries) => dbnpRegistries.list);

export const selectDbnpRegistriesItemById = (itemId: any) =>
    createSelector(selectDbnpRegistriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDbnpRegistriesQueryItems = createSelector([selectDbnpRegistries], (dbnpRegistries) => dbnpRegistries.query);

export const selectDbnpRegistriesCreatedItem = createSelector([selectDbnpRegistries], (dbnpRegistries) => dbnpRegistries.create);

export const selectDbnpRegistriesUpdatedItem = createSelector([selectDbnpRegistries], (dbnpRegistries) => dbnpRegistries.update);

export const selectDbnpRegistriesReadItem = createSelector([selectDbnpRegistries], (dbnpRegistries) => dbnpRegistries.read);

export const selectDbnpRegistriesDeletedItem = createSelector([selectDbnpRegistries], (dbnpRegistries) => dbnpRegistries.delete);

export const selectDbnpRegistriesSearchedItems = createSelector([selectDbnpRegistries], (dbnpRegistries) => dbnpRegistries.search);

export const selectDbnpRegistriesItemsCount = createSelector([selectDbnpRegistries], (dbnpRegistries) => dbnpRegistries.count);

export const selectDbnpRegistriesItemsFilter = createSelector([selectDbnpRegistries], (dbnpRegistries) => dbnpRegistries.filter);